import '../../App.css';
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { FaTimes, FaPlus } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { SlOptionsVertical } from 'react-icons/sl';
import { StyleContext } from '../../context/StyleContext';
import { ApiContext } from '../../context/ApiContext';

function ModalCadastrarCargo({ closeModal }) {
    const { CadastrarCargo, CadastroCargo, setCadastroCargo, Competencias, ListaCompetencia, setError } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [competenciasSelecionadas, setCompetenciasSelecionadas] = useState([]);
    const [competenciaKey, setCompetenciaKey] = useState("")
    const competenciaRef = useRef()

    const handleChange = (event) => {
        setCadastroCargo({ ...CadastroCargo, [event.target.name]: event.target.value })
    }

    const AdicionarCompetencia = () => {
        if (!competenciaKey || competenciaKey === "0") {
            setError("Selecione uma competência.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        const competencia = JSON.parse(competenciaKey);

        const jaExiste = competenciasSelecionadas.some(item => item.id === competencia.id);

        let novasCompetencias;

        if (jaExiste) {
            novasCompetencias = competenciasSelecionadas.filter(item => item.id !== competencia.id);
        } else {
            novasCompetencias = [...competenciasSelecionadas, {
                competenciaKey: competencia.key,
                descricao: competencia.descricao,
                id: competencia.id,
            }];
        }

        setCompetenciasSelecionadas(novasCompetencias);

        competenciaRef.current.value = 0;
        setCompetenciaKey("");
    };

    const ExcluirCompetencia = (id) => {
        const competenciasAtualizadas = competenciasSelecionadas.filter(item => item.id !== id);
        setCompetenciasSelecionadas(competenciasAtualizadas);
    };

    useEffect(() => {
        ListaCompetencia();
    }, [])

    useEffect(() => {
        setCadastroCargo((prev) => ({
            ...prev,
            competencias: competenciasSelecionadas,
        }));
    }, [competenciasSelecionadas]);

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar cargo</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={CadastrarCargo}>
                    <div className="modal-content">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="geral" title={<span>Visão Geral</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cargo</Form.Label>
                                            <Form.Control maxLength={100} onChange={handleChange} name="descricao" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="competencias" title={<span>Competências</span>}>
                                <h1 className='h1-modal'>Competências</h1>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px' }}>
                                    <Col xs={4}>
                                        <Form.Group>
                                            <Form.Select ref={competenciaRef} aria-label="Default select example" onChange={(e) => setCompetenciaKey(e.target.value)}>
                                                <option value="0">Selecione</option>
                                                {Competencias &&
                                                    Competencias?.map((c) => {
                                                        return (
                                                            <option key={c.id} value={JSON.stringify(c)}>{c.descricao}</option>
                                                        )

                                                    })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <button type="button" className="btn-dash btn-criar btn-add" style={btnCriar} onClick={() => AdicionarCompetencia()}><FaPlus /></button>
                                </div>
                                <hr />
                                <Row>
                                    <div style={{ maxHeight: '30vh', width: '100%', overflowY: 'auto' }}>
                                        {competenciasSelecionadas.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <div key={index} className="content-comentario">
                                                        <div className="div-comentario">
                                                            <SlOptionsVertical style={{ marginRight: '15px' }} className='span-bsc'/>
                                                            <span className='span-bsc'>{item.descricao}</span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-del" onClick={() => ExcluirCompetencia(item.id)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => closeModal(false)}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarCargo